import styled from "styled-components";
import { Button } from "@mui/material";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const VerticalButton = styled(Button)<{ open: boolean }>`
    && {
        padding: 0;
        background: transparent !important;
        box-shadow: none !important;
        transform: rotate(-90deg);
        transform-origin: bottom right;

        ${(props) =>
            props.open &&
            `
                display: none;
            `}
        .MuiButton-label {
            color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
        }

        .MuiButton-endIcon {
            padding: 9px 7px;
            background: ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};

            ${(props) =>
                !props.open &&
                `
                    transform: rotate(180deg);
                `}
        }
    }
`;
